export default "__VITE_ASSET__Bd894VlG__"